const dragScroll = () => {

    const CLASSES = {
        'slider': 'roadmap-timeline__container',
        'active': 'active',
        'buttonLeft': 'roadmap-timeline__controls__control--left',
    }

    const slider = document?.querySelector('.' + CLASSES.slider);
    const buttonLeft = document?.querySelector('.' + CLASSES.buttonLeft);

    let isDown = false;
    let startX;
    let scrollLeft;

    const enableLeftScrollControl = () => {
        if (slider != null && slider.scrollLeft > 0) {
            buttonLeft.classList.add(CLASSES.active);
        } else {
            buttonLeft.classList.remove(CLASSES.active);
        }
    }

    if (slider != null) {
        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add(CLASSES.active);
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove(CLASSES.active);
            enableLeftScrollControl();
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove(CLASSES.active);
            enableLeftScrollControl();
        });
        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
            enableLeftScrollControl();
        });
    }

}

export default dragScroll;